/**
 * Dynamic preset selector
 */
 (function() {
  const searchParams = new URLSearchParams(window.location.search);
  if (!searchParams.has('preset')) return;
  const preset = searchParams.get('preset'),
        presetElement = document.querySelector('[data-presets="json"]'),
        presetData = presetElement && JSON.parse(presetElement.innerText) || null,
        dynamicElements = document.querySelectorAll('[data-metafield]');
  if (!presetData || dynamicElements.length === 0) return;
  for (let i = 0; i < dynamicElements.length; i++) {
    const currentElement = dynamicElements[i],
          metafield = currentElement.getAttribute('data-metafield');
    let metafieldPreset = presetData[preset] && presetData[preset][metafield];
    if (!metafieldPreset) {
      console.warn("Preset data for preset " + preset + " missing in metafield " + metafield);
      continue;
    }
    currentElement.innerHTML = metafieldPreset;
  }
})();

/**
 * Visitor counter
 */
(function() {
  /**
   * Calculate the difference between two dates in days.
   */
  function dateDiffInDays(date1, date2) {
    const msPerDay = 1000 * 60 * 60 * 24,
          utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()),
          utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return Math.floor((utc2 - utc1) / msPerDay);
  }

  /**
   * Create a random generator that returns values from 0 to 1. The generator is seeded by the given number.
   * https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
   */
  function randomWithSeed(a) {
    return function() {
      var t = a += 0x6D2B79F5;
      t = Math.imul(t ^ t >>> 15, t | 1);
      t ^= t + Math.imul(t ^ t >>> 7, t | 61);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
  }

  /**
   * Calculate the total views for an article at the moment the user loads a page. The number of views has strictly increased
   * at a later point of time. That is made possible through a seeded random generator that uses the articles publish date.
   * Overwrites values of given objects.
   */
  function calcTotalViews(defaults, data) {
    // Only calc static totals once on page load
    if (data.total === 0) {
      const nextRandom = randomWithSeed(data.startDate.getTime()),
            viewsPerDay = [defaults.total + Math.ceil(nextRandom() * defaults.total * defaults.totalVariance)];
    
      // Calc views for every single day since article creation, the last number is the view number for the current day
      const dayDiff = dateDiffInDays(data.startDate, data.currentDate);
      for (let i = 0; i <= dayDiff; i++) {
        const views = Math.ceil(defaults.viewsPerDay + (nextRandom() * 2 - 1) * (defaults.viewsPerDay * defaults.totalVariance));
        viewsPerDay.push(views);
      }
      data.todayTotal = viewsPerDay.pop();
      data.previousTotal = viewsPerDay.reduce((previous, current) => previous + current);
    }

    // Calc views for the current day with respect to the current time of day
    const msPerDay = 1000 * 60 * 60 * 24,
          currentDateStart = (new Date(data.currentDate.getTime())).setHours(0, 0, 0, 0),
          dayProgress = (data.currentDate - currentDateStart) / msPerDay,
          currentDayViews = Math.ceil(data.todayTotal * dayProgress);
    data.total = data.previousTotal + currentDayViews;
  }

  /**
   * Calc live views by using the average live visitors and add a variance by using a sine with a period length of 20 minutes.
   */
  function calcLiveViews(defaults, data) {
    const periodSeconds = 60 * defaults.livePeriod,
          currentSeconds = data.currentDate.getMinutes() * 60 + data.currentDate.getSeconds(),
          currentVariance = Math.cos(currentSeconds / periodSeconds * 2 * Math.PI) * defaults.live * defaults.liveVariance,
          currentAdditionalVariance = Math.sin(currentSeconds / defaults.liveAdditionalPeriod * 2 * Math.PI) * defaults.liveAddtionialVariance;
    data.live = defaults.live + Math.round(currentVariance + currentAdditionalVariance);
  }

  const visitorsJson = document.querySelector('[data-visitors="json"]'),
        totalElement = document.querySelector('[data-visitors="total"]'),
        liveElement = document.querySelector('[data-visitors="live"]');
  if (!visitorsJson) return;
  const jsonDefaults = JSON.parse(document.querySelector('[data-visitors="json"]').innerText) || {},
        defaultData = {
          date: jsonDefaults.date || "2022-01-01", // Article publish date, needs to be at 0:00:00 time
          total: jsonDefaults.total || 23000, // Starting point for total views
          totalVariance: (jsonDefaults.totalVariance || 35) / 100, // Variance of views (views = average +- average * variance)
          viewsPerDay: jsonDefaults.viewsPerDay || 2100, // Average views per day
          live: jsonDefaults.live || 25, // Average live visitors
          liveVariance: (jsonDefaults.liveVariance || 35) / 100, // Variance of live views (views = average +- average * variance)
          livePeriod: 15, // Period of live visitor count cycle in minutes
          liveAddtionialVariance: 1, // Second variance max value (+-)
          liveAdditionalPeriod: 70, // Second variance period in seconds
          refreshDelay: 3 // Visitor data refresh delay in seconds
        },
        viewData = {
          startDate: new Date(defaultData.date),
          currentDate: new Date(),
          previousTotal: 0,
          todayTotal: 0,
          total: 0,
          live: 0
        };

  /**
   * Calculate and display the live visitor number for the current time
   */
  function refreshLiveViews() {
    viewData.currentDate = new Date();
    const oldLive = viewData.live;
    calcLiveViews(defaultData, viewData);
    liveElement.innerText = new Intl.NumberFormat().format(viewData.live);
    if (viewData.live !== oldLive && oldLive !== 0) {
      liveElement.parentElement.classList.add('blink');
      setTimeout(() => liveElement.parentElement.classList.remove('blink'), 1000);
    }
  }

  if (totalElement && liveElement) {
    calcTotalViews(defaultData, viewData);
    totalElement.innerText = new Intl.NumberFormat().format(viewData.total);
    refreshLiveViews();
    setInterval(refreshLiveViews, defaultData.refreshDelay * 1000);
  }
})();